import api from "./api";

export const UpdateUserAddress = async (id, address) => {
    return await api.put(`UserAddress/${id}`, address);
};